// extracted by mini-css-extract-plugin
module.exports = {"HamburgerIcon":"HamburgerIcon_HamburgerIcon__1g1hL","image":"HamburgerIcon_image__2032g"};